import { push } from "connected-react-router";
import React, {useState} from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH, APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE, APPLICATION_MODE_NEW, APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE } from "../../../app/constants";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { replaceUrlParams } from '../../../app/utils'
import {
  Header,
  NavigationLinkButton,
  Button,
} from "../../../components/RegularComponents";
import { ERROR_STRING } from "../../../app/errors";
import TopNavigationBar from "../../TopNavigationBar";
// import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";

const applicationType = APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE;
const applicationMode = APPLICATION_MODE_NEW;

export const AssociateBrokerNotHasCertificateCompletion = (props) => {
  const dispatch = useDispatch();
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  return (
    <div className="container">
      {/* Title */}
      <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
      <div className="row">
        <div className="col-xs-12 col-lg-10">
          <Header
            style={{ paddingBottom: "30px" }}
            id="associate-broker-continue-application-header"
            header="The applicant's certificate of completion of the Nova Scotia Associate Mortgage Broker course is required"
          />
        </div>
      </div>

      <div className="row bottomMarginLarge">
        <div className="col-xs-12 col-lg-9">
          If they do not have this document, you can't submit an application for their Associate Mortgage Broker licence.
        </div>
      </div>

      <div className="row">
        {null && <div className="col-lg-4 ">
            <Button
              className={"ns-btn-yes-no btn-default"}
              buttonType="primary_regular"
              onClick={()=>{
                  dispatch(
                      saveBusinessLicenceApplicationData(
                        applicationType,
                        applicationMode
                      )
                    )
                  .then((data) => {
                      dispatch(
                          push({
                              pathname: `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_UPLOAD_CRIMINAL_RECORD_CHECK}`,
                          })
                      );
                  })
                  .catch((err) => {
                      setApplicationSaveError(true);
                  });
              }}
              text={"Continue drafting application"}
            />
        </div>}
        <div style={{marginLeft : "-6px"}} className="col-lg-4">
          <NavigationLinkButton
            id={"cancel-quick-link"}
            text={"Save application and return home"}
            onClick={() => {

                let nextUrl = replaceUrlParams(ROUTE_PATH.WELCOME, APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, applicationMode)

                // On to the next item
                dispatch(
                    saveBusinessLicenceApplicationData(
                      applicationType,
                      applicationMode
                    )
                  )
                .then((data) => {
                    dispatch(
                        push(nextUrl)
                    );
                })
                .catch((err) => {
                    setApplicationSaveError(true);
                });
            
            }}
          />
            {applicationSaveError && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};
